import { Select } from "@mantine/core";
import { Dispatch, useCallback } from "react";
import { CatalogueAction } from "../../../hooks/admin/useSystemEmailsPage";
import { SystemEmailCategory } from "../../../services/admin/systemEmails.service";

interface Props {
  value: SystemEmailCategory | null;
  dispatch: Dispatch<CatalogueAction>;
}
const OPTIONS = [
  { value: "report_delivery", label: "Report delivery" },
  { value: "portal_access", label: "Portal access" },
  { value: "portal_auth", label: "Portal security" },
  { value: "staff_account", label: "Staff account" },
  { value: "internal_ops", label: "Internal operations" },
];

export function SystemEmailCategoryFilter({ value, dispatch }: Props) {
  const change = useCallback(
    (next: string | null) =>
      dispatch({ type: "category", value: next as SystemEmailCategory | null }),
    [dispatch]
  );
  return (
    <Select
      clearable
      data={OPTIONS}
      label="Category"
      onChange={change}
      placeholder="All categories"
      value={value}
    />
  );
}
